export const trackPageview = (url, title = document.title) => {
  window.dataLayer.push({
    event: 'GAtrackVirtualPageview',
    virtualPageviewUrl: url,
    virtualPageviewTitle: title,
  });
};

export const trackEvent = ({
  category, action, label, value,
}) => {
  window.dataLayer.push({
    event: 'GAevent',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value,
  });
};
